import anime from '../assets/style-previews/anime.webp';
import classic from '../assets/style-previews/classic.webp';
import flat from '../assets/style-previews/flat.webp';
import hyperreal from '../assets/style-previews/hyperreal.webp';
import softCartoon from '../assets/style-previews/pixar.webp';
import watercolour from '../assets/style-previews/watercolour.webp';

/**
 * Sample pictures from Builder 2.0 (PR #160): one scene, the same for
 * every style, drawn once with the image model and bundled with the app. Keyed by the system
 * styles' ids, which the seed fixes for every deployment of every brand.
 *
 * Bundled rather than set as `Style.previewAssetId`: an asset row needs an owning user and an
 * object in the deployment's bucket, and the seed that creates the styles reaches neither.
 */
export const SYSTEM_STYLE_PREVIEWS: Readonly<Record<string, string>> = {
  '0f6b1d3a-0000-4000-8000-000000000005': hyperreal,
  '0f6b1d3a-0000-4000-8000-000000000006': anime,
  '0f6b1d3a-0000-4000-8000-000000000001': softCartoon,
  '0f6b1d3a-0000-4000-8000-000000000002': watercolour,
  '0f6b1d3a-0000-4000-8000-000000000003': flat,
  '0f6b1d3a-0000-4000-8000-000000000004': classic,
};
